import f3tch, {profile} from 'f3tch';

import getApiEndpoint from '../../api/lib/getEndpoint.lib.api';
import isApiError from '../../api/errors/isApiError.error.api';
import getAuthToken from '../../auth/lib/getAuthToken.lib.auth';

const jsonNoUrlProfile = () =>
  profile()
    .headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    })
    .responder(async (response) => {
      await isApiError(response);
      return response.json();
    });

const getSuggestedReplyApi = ({
  conversationId,
  token = getAuthToken('chaya'),
  url = getApiEndpoint('chaya'),
}) =>
  f3tch(`${url}/bots/conversations/${conversationId}/suggested_reply/`)
    .profile(jsonNoUrlProfile())
    .headers({
      Authorization: `JWT ${token}`,
    })
    .get();

export default getSuggestedReplyApi;
